import React from 'react'
import Modal from 'react-responsive-modal'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'

const toDateInput = (val) => val ? val.slice(0, 10) : ''

export default function PublicLoadModal({ data, closeModal, height, addMode, onSave }) {

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: data ? { ...data, begdate: toDateInput(data.begdate), enddate: toDateInput(data.enddate) } : {},
    enableReinitialize: true,
    onSubmit: (vals) => {
      if (onSave) onSave({
        ...vals,
        begdate: vals.begdate ? `${vals.begdate}T00:00:00+00:00` : vals.begdate,
        enddate: vals.enddate ? `${vals.enddate}T00:00:00+00:00` : vals.enddate,
      })
    }
  })

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{ modal: styles.custom }}
    >
      <div className={styles.modalLocal}>
        <h3 className={styles.title}>Общественная нагрузка</h3>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsColomn}>
            <Input
              label='Общественная нагрузка'
              name='public_load'
              value={values.public_load || ''}
              onChange={handleChange}
              style={{ width: '400px' }}
            />
            <Input
              type='date'
              label='Дата с'
              name='begdate'
              value={values.begdate || ''}
              onChange={handleChange}
            />
            <Input
              type='date'
              label='Дата по'
              name='enddate'
              value={values.enddate || ''}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
    </Modal>
  )
}
